import { IMAGE_EXTENSIONS } from './IMAGE_EXTENSIONS';

/**
 * Returns true if the file is (or looks like) an image.
 * Falls back to checking the file extension when `file.type` is empty —
 * macOS screenshots and some clipboard pastes don't set MIME type.
 */
export function looksLikeImage(fileObject: File): boolean {
	if (fileObject.type.startsWith('image/')) {
		return true;
	}
	// Some browsers/OS don't set MIME on screenshots — fall back to extension.
	const ext = fileObject.name.split('.').pop()?.toLowerCase() ?? '';
	return IMAGE_EXTENSIONS.has(ext);
}
